:host {
  display: block;
  width: 85%;
  max-width: 1200px;
}

.container {
  padding: 16px 16px 20px;
  margin: calc(var(--spacer) * 3) calc(var(--spacer) * 3);
}

.inner-container {
  height: 100%;

  border: 1px solid var(--chart-101-pressed-dividers);
  border-radius: 4px;

  margin-top: 10px;
  padding: 10px 20px;
}

.initial-loading-error-panel {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: start;

  gz-text {
    width: fit-content;
  }
}

.main-product-box {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.buy-button-container {
  min-width: 220px;
  display: flex;
  justify-content: flex-end;
}

.warning-box {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  &.with-button {
    & > :first-child {
      flex-basis: 70%; /* Sets the base width of the first item to % of the parent container */
      flex-grow: 0; /* Prevents the first item from growing */
      flex-shrink: 0; /* Prevents the first item from shrinking */
    }
  }
}

gz-info-box {
  padding: calc(var(--spacer) * 1) 0;
  --info-box-max-width: 100%;
  --info-box-width: 100%;
  --info-box-message-width: 100%;
}

gz-input-number {
  --floating-label-transition: none;
}

gz-button::part(button) {
  width: 100%;
}
